import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { campaignJobBoardQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignTypeDTO } from "@/types/response/CampaignType";
import { PagedResponse } from "@/types/response/PagedResponse";

interface UseCampaignJobBoardMonthsParams {
  clientId?: string;
  descending?: boolean;
  isInvoiced?: boolean;
  month?: string;
  orderBy?: string;
  page?: number;
  pageSize?: number;
  year?: string;
}

export function useCampaignJobBoardMonths(
  params: UseCampaignJobBoardMonthsParams
) {
  return useQuery<PagedResponse<CampaignTypeDTO>, AxiosError>({
    queryKey: campaignJobBoardQueryKeys.months.list(params),
    queryFn: () =>
      instance
        .get<PagedResponse<CampaignTypeDTO>>(
          `/api/v2/Campaigns/${params.year}/${params.month}`,
          {
            params: {
              clientId: params.clientId,
              descending: params.descending,
              isInvoiced: params.isInvoiced ?? false,
              orderBy: params.orderBy,
              page: params.page ?? 1,
              pageSize: params.pageSize ?? 10,
            },
          }
        )
        .then((res) => res.data),
    enabled: !!params.year && !!params.month,
    refetchOnMount: true,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
